module.exports = __webpack_public_path__ + "img/nmgca.11632d2b.jpg";